import { getDataMapper, mapField, isPrimitive, isNil } from "@/shared";

export const mapReportPaymentsFiltersToServer = getDataMapper({
    period_from: mapField("period", (period) => {
        return isPrimitive(period.interval) || isNil(period.interval)
            ? null
            : period.interval.from;
    }),
    period_to: mapField("period", (period) => {
        return isPrimitive(period.interval) || isNil(period.interval)
            ? null
            : period.interval.to;
    }),
    period_interval: mapField("period", (period) => {
        return isPrimitive(period.interval) ? period.interval : null;
    }),
    pay_type: mapField("paymentType"),
    type: mapField("type"),
    user_id: mapField("employee", (employee) => employee.userId),
    point: mapField("pointId", Number),
});
